import { z } from 'zod';
import { ISODateTimeSchema, UUIDSchema } from './common';
import { ImageWithContentTypeSchema } from './file';
import { AppraiserLegacyUserSchema, ClientPortalLegacyUserSchema } from './user';
import { ValuationDocumentSchema, ValuationImageSchema } from './valuation';
const BaseMessageFields = {
    uuid: UUIDSchema,
    content: z.string(),
    is_edited: z.boolean().optional(),
    created_on: ISODateTimeSchema,
    updated_on: ISODateTimeSchema,
    documents: ValuationDocumentSchema.array(),
    user_id: z.number().optional(),
    user_name: z.string().optional(),
};
const HumanMessageFields = {
    message_type: z.enum(['existing_message', 'deleted_message']),
    user_name: z.string(),
    organization_name: z.string().optional(),
};
const UserMessageFields = {
    author_type: z.literal('internal_user'),
    user_id: z.number(),
    external_participant_id: z.never().optional(),
};
const ExternalParticipantMessageFields = {
    author_type: z.literal('external_participant'),
    external_participant_id: UUIDSchema,
    user_id: z.never().optional(),
};
const SystemMessageFields = { message_type: z.literal('system_message'), author_type: z.literal('system') };
const ThreadFields = {
    uuid: UUIDSchema,
    order_uuid: UUIDSchema,
    topic: z.string(),
    organization_uuid: UUIDSchema,
    user_id: z.number(),
    user_name: z.string(),
    created_on: ISODateTimeSchema,
    updated_on: ISODateTimeSchema,
    participant_ids: z.number().array(),
};
export const AppraiserBaseMessageSchema = z.object({
    ...BaseMessageFields,
    images: ValuationImageSchema.array(),
});
const AppraiserHumanMessageSchema = AppraiserBaseMessageSchema.extend(HumanMessageFields);
export const AppraiserUserMessageSchema = AppraiserHumanMessageSchema.extend(UserMessageFields);
export const AppraiserExternalParticipantMessageSchema = AppraiserHumanMessageSchema.extend(ExternalParticipantMessageFields);
export const AppraiserExistingMessageSchema = z.union([AppraiserUserMessageSchema, AppraiserExternalParticipantMessageSchema]);
export const AppraiserSystemMessageSchema = AppraiserBaseMessageSchema.extend(SystemMessageFields);
export const AppraiserMessageSchema = z.union([
    AppraiserExistingMessageSchema,
    AppraiserSystemMessageSchema,
]);
export const AppraiserThreadSchema = z.object({
    ...ThreadFields,
    messages: AppraiserMessageSchema.array(),
    participant_users: AppraiserLegacyUserSchema.array(),
});
export const ClientPortalBaseMessageSchema = z.object({
    ...BaseMessageFields,
    images: ImageWithContentTypeSchema.array(),
});
const ClientPortalHumanMessageSchema = ClientPortalBaseMessageSchema.extend(HumanMessageFields);
export const ClientPortalUserMessageSchema = ClientPortalHumanMessageSchema.extend(UserMessageFields);
export const ClientPortalExternalParticipantMessageSchema = ClientPortalHumanMessageSchema.extend(ExternalParticipantMessageFields);
export const ClientPortalExistingMessageSchema = z.union([ClientPortalUserMessageSchema, ClientPortalExternalParticipantMessageSchema]);
export const ClientPortalSystemMessageSchema = ClientPortalBaseMessageSchema.extend(SystemMessageFields);
export const ClientPortalMessageSchema = z.union([ClientPortalExistingMessageSchema, ClientPortalSystemMessageSchema]);
export const ClientPortalThreadSchema = z.object({
    ...ThreadFields,
    messages: ClientPortalMessageSchema.array(),
    participant_users: ClientPortalLegacyUserSchema.array(),
});
